// Petnoya cart — AJAX add/change/remove + drawer open/close.
// Uses event delegation so listeners survive section refreshes.
(function () {
  const SECTION_IDS = ['pn-cart-drawer', 'pn-cart-main'];

  function moneyFormat(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  }

  function changeCart(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    }).then(r => r.json());
  }

  function updateHeaderCount(cart) {
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
    document.querySelectorAll('[data-cart-count-wrap]').forEach(el => {
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function refreshSections() {
    const sections = SECTION_IDS.join(',');
    return Promise.all([
      fetch('/?sections=' + sections, { headers: { Accept: 'application/json' } }).then(r => r.json()),
      getCart(),
    ]).then(([json, cart]) => {
      SECTION_IDS.forEach(id => {
        if (!json[id]) return;
        const wrap = document.createElement('div');
        wrap.innerHTML = json[id];
        const next = wrap.querySelector('[data-section-id="' + id + '"]');
        const cur = document.querySelector('[data-section-id="' + id + '"]');
        if (next && cur) cur.replaceWith(next);
      });
      updateHeaderCount(cart);
    });
  }

  function openDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    const back = document.querySelector('[data-cart-drawer-back]');
    if (!drawer) {
      // Fallback: navigate to cart page if drawer somehow missing.
      window.location = '/cart';
      return;
    }
    drawer.classList.add('is-open');
    if (back) back.classList.add('is-open');
    document.body.classList.add('pn-cart-open');
    const closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    const back = document.querySelector('[data-cart-drawer-back]');
    if (drawer) drawer.classList.remove('is-open');
    if (back) back.classList.remove('is-open');
    document.body.classList.remove('pn-cart-open');
  }

  // ----- Delegated click handler (survives any section re-render) -----
  document.addEventListener('click', async (e) => {
    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
      return;
    }

    const closeBtn = e.target.closest('[data-cart-close], [data-cart-drawer-back]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    const stepBtn = e.target.closest('[data-line-change]');
    if (stepBtn) {
      e.preventDefault();
      const line = parseInt(stepBtn.dataset.line, 10);
      const delta = parseInt(stepBtn.dataset.delta, 10);
      const item = stepBtn.closest('[data-cart-line]');
      const qtyEl = item && item.querySelector('[data-line-qty], [data-line-qty-input]');
      const current = qtyEl ? parseInt(qtyEl.textContent || qtyEl.value, 10) || 1 : 1;
      const next = Math.max(0, current + delta);
      await changeCart(line, next);
      await refreshSections();
      return;
    }

    const removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      const line = parseInt(removeBtn.dataset.line, 10);
      await changeCart(line, 0);
      await refreshSections();
      return;
    }
  });

  document.addEventListener('change', async (e) => {
    const qtyInput = e.target.closest('[data-line-qty-input]');
    if (!qtyInput) return;
    const line = parseInt(qtyInput.dataset.line, 10);
    const next = Math.max(0, parseInt(qtyInput.value, 10) || 0);
    await changeCart(line, next);
    await refreshSections();
  });

  // ----- AJAX add-to-cart -----
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action="/cart/add"], form[action^="/cart/add"]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    const fd = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd,
      });
      if (!res.ok) throw new Error('Add failed');
      await refreshSections();
      openDrawer();
    } catch (err) {
      form.submit();
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  // ESC closes drawer
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  window.PNCart = { open: openDrawer, close: closeDrawer, refresh: refreshSections, money: moneyFormat };
})();
